import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      width="24px"
      height="7px"
      viewBox="0 0 24 7"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M3.11111112,6.62222225 C1.3928919,6.62222225 -4.97379915e-14,5.22933035 -4.97379915e-14,3.51111112 C-4.97379915e-14,1.7928919 1.3928919,0.4 3.11111112,0.4 C4.82933032,0.4 6.22222216,1.79289193 6.22222216,3.51111112 C6.22222216,5.22933032 4.82933032,6.62222225 3.11111112,6.62222225 L3.11111112,6.62222225 Z M12,6.62222225 C10.2817808,6.62222225 8.88888887,5.22933035 8.88888887,3.51111112 C8.88888887,1.7928919 10.2817808,0.4 12,0.4 C13.7182192,0.4 15.111111,1.79289193 15.111111,3.51111112 C15.111111,5.22933032 13.7182192,6.62222225 12,6.62222225 L12,6.62222225 Z M20.8888889,6.62222225 C19.1706696,6.62222225 17.7777777,5.22933035 17.7777777,3.51111112 C17.7777777,1.7928919 19.1706696,0.4 20.8888889,0.4 C22.6071081,0.4 23.9999999,1.79289193 23.9999999,3.51111112 C23.9999999,5.22933032 22.6071081,6.62222225 20.8888889,6.62222225 L20.8888889,6.62222225 Z"
        id="形状"
      />
    </svg>
  )
}

const MoreIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
MoreIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
MoreIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default MoreIcon
